import type { DataObjectIndicator } from "@certa/queries/types/dataObjectsAPIs.types";
import type {
  DataObjectFieldsSchemaRaw,
  DataObjectUISchemaFieldRaw
} from "@certa/types/src/dataObjects.types";
import { Ellipsis } from "@certa/catalyst/components/Typography";

import { DataObjectTableFieldRAGCell } from "./DataObjectTableFieldRAGCell";
import { DataObjectFieldIndicatorCell } from "./DataObjectFieldIndicatorCell";
import { DataObjectUrlField } from "../DataObjectFields/DataObjectUrlField";
import { getFormattedFieldValue } from "../../../utils/dataObject/fields";
import { useIntl } from "react-intl";

type DataObjectTableFieldsCellProps = {
  uISchema?: DataObjectUISchemaFieldRaw;
  translatedUISchema?: DataObjectUISchemaFieldRaw;
  schema: DataObjectFieldsSchemaRaw["properties"][string];
  value?: string | number | null;
  fieldIndicator?: DataObjectIndicator;
};

export const DataObjectTableFieldsCell = (
  props: DataObjectTableFieldsCellProps
) => {
  const { uISchema, translatedUISchema, schema, value, fieldIndicator } = props;

  const intl = useIntl();
  const fieldType = uISchema?.type || schema?.type;

  const fieldRAG = uISchema?.rules?.rag;
  const translatedFieldRAG = translatedUISchema?.rules?.rag;

  // Value sometimes is null or undefined since it is coming from the table row.original
  const formattedFieldValue =
    value !== null && value !== undefined
      ? getFormattedFieldValue({
          value,
          type: fieldType,
          format: uISchema?.format,
          intl
        })
      : null;

  switch (fieldType) {
    case "url":
      return <DataObjectUrlField url={formattedFieldValue as string} />;
    default:
      if (fieldIndicator) {
        return (
          <DataObjectFieldIndicatorCell
            indicator={fieldIndicator}
            formattedFieldValue={formattedFieldValue}
          />
        );
      }
      // TODO: Add RAG support only for specific fields once we start supporting
      // other field types in the table
      return fieldRAG && value !== null && value !== undefined ? (
        <DataObjectTableFieldRAGCell
          rag={fieldRAG}
          translatedRag={translatedFieldRAG}
          fieldValue={value}
          formattedFieldValue={formattedFieldValue}
        />
      ) : (
        <Ellipsis>
          {formattedFieldValue === 0 ? "0" : formattedFieldValue || "-"}
        </Ellipsis>
      );
  }
};
